import { getCurrency, getCurrencySymbol } from 'globals/utils';
import defaultLocales from 'globals/locales/default';
import { CurrencyProps } from 'models/reusable-parts/currency';

export const getMinimumSpending = (price?: CurrencyProps) => {
  const currency = price && getCurrency({ ...price });
  const { suffix } = defaultLocales.payAsYouGrowSection.minimumSpending;
  return `${currency}${suffix} `;
};

export const getSymbol = (price?: CurrencyProps): string | undefined => {
  return price && getCurrencySymbol({ ...price });
};
